if (!customElements.get('wishlist-component')) {
  class Wishlist extends HTMLElement {
    constructor() {
      super();
      this.body = document.body;
    }

    connectedCallback() {
      this.updateHeartIcon();
      this.updateWishlistContent();
      this.closeEvent();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick.bind(this));
    }
    
   closeDrawer() {
      this.body.querySelector(".wishlist-drawer").classList.remove("active");
      document.querySelector("cart-drawer.drawer").style.visibility = "hidden";
      document.body.classList.remove("overflow");
    }
  
    closeEvent() {
      const closeButton = this.body.querySelector(".wishlist__close");
      closeButton?.addEventListener("click", () => this.closeDrawer());
    }
    
    handleClick(event) {
      const heartItem = event.target.closest('.product__card__whislist-icon');
      if (heartItem) {
        this.toggleHeart(heartItem);
      }
    }

    toggleHeart(heartItem) {
      if (heartItem.classList.contains("active")) {
        this.removeItem(heartItem);
      } else {
        this.addItem(heartItem);
      }
    }

    addItem(heartItem) {
      const handle = heartItem.dataset.handle;
      heartItem.classList.add("active");
      this.drawerElement = this.body.querySelector("cart-drawer.drawer");

      if (this.drawerElement) {
        this.drawerElement.style.visibility = "visible";
      }

      setTimeout(()=>{
        this.body.querySelector("#wishlistDrawer")?.classList.add("active");
      },500)
      this.body.querySelector(".wishlist__main__cart__btn .wishlist__add__to__cart")?.classList.remove("hide");
      this.body.querySelector(".wishlist__main__cart__btn .wishlist__view__product")?.classList.add("hide")
      this.fetchProductData(handle, "add");
    }

    removeItem(heartItem) {
      const handle = heartItem?.dataset.handle;
      heartItem?.classList.remove("active");
      this.drawerElement = this.body.querySelector("cart-drawer.drawer");

      if (this.drawerElement) {
        this.drawerElement.style.visibility = "hidden";
      }

      this.body.querySelector("#wishlistDrawer")?.classList.remove("active");
      // this.body.classList.remove("overflow");
      this.fetchProductData(handle, "remove");
    }

    
  fetchProductData(handle, action) {
    if (!handle) {
      console.error('Handle is undefined');
      return;
    }

    fetch(window.Shopify.routes.root + `products/${handle}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to fetch product data. Status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        let url = window.location.href;
        const urlParams = new URLSearchParams(new URL(url).search);
        const variantId = urlParams.get('variant');
        let variantArr = product.variants.map((item) => item);
        const filteredVariants = variantArr.filter(item => item.id == variantId);
        const variant1Value = variantId 
        ? filteredVariants[0]?.option1 
        : product.variants[0]?.option1;

      const variant2Value = variantId 
        ? filteredVariants[0]?.option2 
        : product.variants[0]?.option2;

      const wishlistItem = {
        handle: product.handle,
        id: product.variants[0].id,
        title: product.title,
        variant1: variant1Value && variant1Value !== "Default Title" 
          ? `weight: ${variant1Value}` 
          : "",
        variant2: variant2Value && variant2Value.trim() !== "" && variant2Value.toLowerCase() !== "null"
          ? `flavour: ${variant2Value}` 
          : "",
        image: product.featured_image ? product.featured_image : "",
        url: product.url,
        available: product.variants?.[0]?.available ?? true
      };

        let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        if (action === "add") {
          wishlist = wishlist.filter(item => item.handle !== wishlistItem.handle);
          wishlist.push(wishlistItem);
        } else if (action === "remove") {
          wishlist = wishlist.filter(item => item.handle !== wishlistItem.handle);
        }

        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        this.updateHeartIcon();
        this.updateWishlistContent();
      })
      .catch(err => {
        console.error('Error fetching product data:', err);
      });
  }

  updateHeartIcon() {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    let handleWishlist = document.querySelectorAll(".product__card__whislist-icon");

    wishlist.forEach((item) => {
      const matchingElement = Array.from(handleWishlist).find((element) => element.dataset.handle === item.handle);
      if (matchingElement) {
        matchingElement.classList.add("active");
      }
    });
  }

  updateWishlistContent() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    const wishlistCountElement = this.body.querySelector('#wishlistItems');
    const wishlistDrawer = this.body.querySelector("#wishlistDrawer");

    if (wishlistCountElement) {
      wishlistCountElement.setAttribute("data-count", wishlist.length.toString());
    }

    if (wishlistDrawer) {
      const wishlistContainer = wishlistDrawer.querySelector('.wishlist-items');
      if (wishlistContainer) {
        wishlistContainer.innerHTML = '';

       wishlist.forEach(item => {
        if (!item) return console.error('Item is undefined or null');

        const wishlistItemDiv = document.createElement('div');
        wishlistItemDiv.className = 'wishlist-item';
        wishlistItemDiv.dataset.handle = item.handle;

        const productImageDiv = document.createElement('div');
        productImageDiv.className = 'product-image';

        const productBadge = document.createElement('div');
        productBadge.className = 'product-badge';
        if(item.available == false){
         productBadge.textContent = 'Sold Out';
        }
        
        const productTitleDiv = document.createElement('div');
        productTitleDiv.className = 'product-title';

        const variantDiv = document.createElement('div');
        variantDiv.className = 'variant-item';

        const productTitle = document.createElement('h3');
        productTitle.textContent = item.title;

        const productImage = document.createElement('img');
        productImage.src = item.image || '';
        productImage.alt = item.title;

        const variants = document.createElement('div');
        variants.className = 'variants';

        const variant1 = document.createElement('div');
        variant1.textContent = item.variant1 || '';

        const variant2 = document.createElement('div');
        variant2.textContent = item.variant2 || '';

        const cancelButton = document.createElement('div');
        cancelButton.className = 'remove-btn';
        cancelButton.innerHTML = `
          🗑️
        `;

        cancelButton.addEventListener('click', () => {
          this.removeFromWishlist(item.handle);
          this.updateHeartIcon();
        });

        const productLink = document.createElement('a');
        productLink.href = item.url || '#';
        productLink.appendChild(productImage);

        productImageDiv.append(productLink, productBadge);
        variants.append(productTitle, variant1, variant2);
        productTitleDiv.append(variants, cancelButton);

        wishlistItemDiv.append(productImageDiv, productTitleDiv);
        wishlistContainer.appendChild(wishlistItemDiv);
        wishlistContainer.classList.remove("is-wishlist-empty");
      });

        this.updateWishlistCount(wishlist.length);
      }
    }

  }

  removeFromWishlist(handle) {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    wishlist = wishlist.filter(item => item.handle !== handle);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    this.body.querySelectorAll("wishlist-component .product__card__whislist-icon").forEach(icon => {
      const iconHandle = icon.dataset.handle;
      wishlist.some(item => item.handle === iconHandle)
        ? icon.classList.add('active')
        : icon.classList.remove('active');
    });
    this.updateWishlistContent();
    if(wishlist.length == 0){
      const wishlistContainer = this.body.querySelector('#wishlistDrawer #wishlistItems').querySelector(".wishlist-items");
        wishlistContainer.innerHTML = '<p class="wishlist_empty" style="color:#000"> Your WishList Is Empty </p>';
        wishlistContainer.classList.add("is-wishlist-empty");
        this.body.querySelector(".wishlist__main__cart__btn .wishlist__add__to__cart").classList.add("hide");
        this.body.querySelector(".wishlist__main__cart__btn .wishlist__view__product").classList.remove("hide")
    }
  }


  updateWishlistCount(count) {
    const wishlistCountElement = document.querySelector(".wishlist-drawer").querySelector("#wishlistItems");
    if (wishlistCountElement) {
      wishlistCountElement.setAttribute("data-count", count.toString());
    }

    document.querySelector(".wishlist__name").innerHTML = `
      <div class="count">Your Wishlist (${count})</div>`;
    } 
  }
  customElements.define('wishlist-component', Wishlist);
}

